/*
 *
 * PageState actions
 *
 */

import * as CONSTANTS from "./constants";

/**
 * set/clear treatmentFromTimeSlot.
 */
export function setTreatmentFromTimeSlotAction(value) {
  return {
    type: CONSTANTS.SET_TREATMENT_TIME_SLOT,
    value,
  };
}
export function clearTreatmentFromTimeSlotAction() {
  return setTreatmentFromTimeSlotAction(null);
}
